<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>统计</el-breadcrumb-item>
      <el-breadcrumb-item>设备找回</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div>
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="时间区间" style="margin: 0">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            ></el-date-picker> </el-form-item
        ></el-form>
      </div>
      <div class="mt-10">
        <el-button type="primary" size="small" @click="submitForm()"
          >筛选</el-button
        >
      </div>
    </div>
    <div class="panel mt-20">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="概览" name="tab1"
          ><el-table
            :data="totalResults"
            stripe
            style="width: 100%"
            key="followups2"
          >
            <el-table-column prop="name" label="销售"> </el-table-column>
            <el-table-column prop="sn_total" label="SN找回数"></el-table-column>
            <el-table-column
              prop="name_plate_total"
              label="铭牌找回数"
            ></el-table-column> </el-table
        ></el-tab-pane>
        <el-tab-pane label="SN找回明细" name="tab2"
          ><el-table
            :data="snDetailResults"
            stripe
            style="width: 100%"
            key="followups3"
          >
            <el-table-column label="序列号/设备号">
              <template slot-scope="scope">
                <span> 序列号：{{ scope.row.serial_number }}</span>
                <br />
                <span> 设备号：{{ scope.row.equipment_number }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="客户"
              ><template slot-scope="scope">
                <customer-link
                  :customer="scope.row.customer"
                ></customer-link> </template
            ></el-table-column>
            <el-table-column prop="user.name" label="操作人"></el-table-column>
            <el-table-column label="添加时间"
              ><template slot-scope="scope">
                {{ formatTime(scope.row.found_time) }}
              </template></el-table-column
            >
            <el-table-column label="操作" v-if="auth.isPlatformUser()">
              <template slot-scope="scope">
                <el-popconfirm
                  title="确实变更SAP同步状态？"
                  v-if="!scope.row.sap_sync"
                  @confirm="swithSapSyncStatus(scope.row, scope.$index)"
                  ><el-button
                    slot="reference"
                    style="margin-top: 5px"
                    type="text"
                    plain
                    size="mini"
                    class="text-primary"
                    >维护到SAP</el-button
                  >
                </el-popconfirm>
                <div v-else class="text-info-12" style="margin-top: 5px">
                  <i class="el-icon-check"></i>
                  已维护到SAP
                </div>
              </template>
            </el-table-column>
          </el-table></el-tab-pane
        >
        <el-tab-pane label="铭牌找回明细" name="tab3"
          ><el-table
            :data="npDetailResults"
            stripe
            style="width: 100%"
            key="followups3"
          >
            <el-table-column label="序列号/设备号">
              <template slot-scope="scope">
                <div class="flex-row">
                  <span> 序列号：{{ scope.row.serial_number }} </span>
                  <viewer
                    v-if="
                      scope.row.name_plate && scope.row.name_plate.length > 0
                    "
                    class="viewer"
                    ref="viewer"
                  >
                    <template slot-scope="scope2">
                      <auth-img
                        tag="el-image"
                        style="width: 16px; height: 16px; margin-left: 5px"
                        :src="scope.row.name_plate"
                        :preview-src-list="[scope.row.name_plate]"
                      />
                    </template>
                  </viewer>
                </div>
                <span> 设备号：{{ scope.row.equipment_number }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="客户"
              ><template slot-scope="scope">
                <customer-link
                  :customer="scope.row.customer"
                ></customer-link> </template
            ></el-table-column>
            <el-table-column prop="user.name" label="操作人"></el-table-column>
            <el-table-column label="添加时间"
              ><template slot-scope="scope">
                {{ formatTime(scope.row.name_plate_time) }}
              </template></el-table-column
            >
            <el-table-column label="操作" v-if="auth.isPlatformUser()">
              <template slot-scope="scope">
                <el-popconfirm
                  title="确实变更SAP同步状态？"
                  v-if="!scope.row.sap_sync"
                  @confirm="swithSapSyncStatus(scope.row, scope.$index)"
                  ><el-button
                    slot="reference"
                    style="margin-top: 5px"
                    type="text"
                    plain
                    size="mini"
                    class="text-primary"
                    >维护到SAP</el-button
                  >
                </el-popconfirm>
                <div v-else class="text-info-12" style="margin-top: 5px">
                  <i class="el-icon-check"></i>
                  已维护到SAP
                </div>
              </template>
            </el-table-column>
          </el-table></el-tab-pane
        >
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  effectiveDeviceTotal,
  effectiveDeviceSNDetail,
  updateCustomerDeviceSapsync,
  effectiveDeviceNamePlateDetail,
} from '../../service/getData'
import Vue from 'vue'
import { formatTime } from '@/util/index'
import { host, thumbnailImagePath, originImagePath } from '@/config/env'
import auth from '@/util/auth'
export default {
  data() {
    return {
      auth,
      thumbnailImagePath,
      originImagePath,
      host,
      pickerOptions: {
        shortcuts: [
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date()
              const start = new Date(new Date().getFullYear(), 0)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 6)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近十二个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 12)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      totalResults: [],
      snDetailResults: [],
      npDetailResults: [],
      formatTime,
      activeTab: 'tab1',
      filter: {
        date: null,
      },
    }
  },
  created() {
    const start = new Date()
    start.setMonth(start.getMonth() - 1)
    const end = new Date()
    this.filter.date = [start, end]

    this.requestEffectiveDeviceTotal()
  },
  methods: {
    async requestEffectiveDeviceTotal() {
      if (this.filter.date == null || this.filter.date.length != 2) {
        this.$message.error('请选择一个时间范围')
        return
      }

      let end = new Date(this.filter.date[1])
      end.setDate(end.getDate() + 1)
      let data = {
        start_date: Vue.time(this.filter.date[0]).format('YYYY-MM-DD'),
        end_date: Vue.time(end).format('YYYY-MM-DD'),
      }
      let res = await effectiveDeviceTotal(data)
      if (res.code == 0) {
        this.totalResults = res.data.list
      }

      this.requestNamePlateDetail(data)
      this.requestSNDetail(data)
    },
    async requestSNDetail(data) {
      let res = await effectiveDeviceSNDetail(data)
      if (res.code == 0) {
        this.snDetailResults = res.data.list
      }
    },
    async requestNamePlateDetail(data) {
      let res = await effectiveDeviceNamePlateDetail(data)
      if (res.code == 0) {
        this.npDetailResults = res.data.list
      }
    },
    submitForm() {
      this.requestEffectiveDeviceTotal()
    },
    async swithSapSyncStatus(device, index) {
      let data = {
        sap_sync: 1 - device.sap_sync,
        id: device.id,
      }
      let res = await updateCustomerDeviceSapsync(data)
      if (res.code == 0) {
        device.sap_sync = res.data.sap_sync
        this.$message.success('操作成功')

        this.snDetailResults.map((item) => {
          if (item.id == device.id) {
            item.sap_sync = res.data.sap_sync
          }
        })

        this.npDetailResults.map((item) => {
          if (item.id == device.id) {
            item.sap_sync = res.data.sap_sync
          }
        })
      }
    },
  },
}
</script>